import MenuList from "@/components/MenuList/MenuList.vue"
import SidebarBurger from "@/components/SidebarBurger/SidebarBurger.vue";
import btnCloseNotBorder from "@/components/btnCloseNotBorder/btnCloseNotBorder.vue"
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'SidebarMenu',
    watch: {
      '$route'() {
          if (this.getWidth <= 950 && !this.toggleSidebar) this.changeVision()
      }
    },
    data() {
        return {
            list1: {
                title: 'MENU',
                data: [
                    {id: 1, title: 'My gates', to: '/my-gates'},
                    {id: 2, title: 'Pricing', to: '/pricing'},
                    // {id: 2, title: 'UI ToolKit', to: '/uitoolkit'},
                    {id: 3, title: 'Support', to: '/support'},
                    // {id: 3, title: 'Shared Settings', to: '/new-gate'}
                ]
            },
            flag: true
        }
    },
    components: {
        MenuList, btnCloseNotBorder, SidebarBurger
    },
    methods: {
        ...mapActions([
            'changeVision'
        ])
    },
    computed: {
        ...mapGetters([
            'toggleSidebar',
            'isLoggedIn',
            'getWidth'
        ])
    }
}
